import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import LoginScreen from "@/components/LoginScreen";
import ChatLayout from "@/components/ChatLayout";
import { WidgetEmbed, EmbedGuide } from "@/components/FloatingChatWidget";
import AdminDashboard from "@/pages/AdminDashboard";

const STORAGE_KEY = "ruangchat_user";

function App() {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        setUser(JSON.parse(saved));
      } catch {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
    setReady(true);
  }, []);

  const handleLogin = (u) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(u));
    setUser(u);
  };

  const handleLogout = () => {
    localStorage.removeItem(STORAGE_KEY);
    setUser(null);
  };

  if (!ready) return <div className="h-screen w-full bg-slate-100 dark:bg-slate-950" />;

  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false} storageKey="ruangchat-theme">
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={user ? <ChatLayout user={user} onLogout={handleLogout} /> : <LoginScreen onLogin={handleLogin} />}
            />
            <Route
              path="/widget"
              element={<WidgetEmbed />}
            />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route
              path="/embed"
              element={<EmbedGuide />}
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </ThemeProvider>
  );
}

export default App;
